<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5
        class="modal-title"
        id="CycleModalLabel"
      >Edit</h5>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      ></button>
    </div>
    <div class="modal-body">
      <form
        class="form-horizontal needs-validation"
        novalidate
        id="formEditCycle"
      >
        <div class="row">
          <div class="col-6">
            <div class="mb-3">
              <label class="col-12">Supplier Code</label>
              <div class="col-12">
                <input
                  type="text"
                  class="form-control"
                  v-model="spl_name"
                  readonly
                />
                <input
                  type="hidden"
                  class="form-control"
                  v-model="cdc_id"
                />
              </div>
            </div>
            <div class="mb-3">
              <label class="col-12">Dock</label>
              <div class="col-12">
                <input
                  type="text"
                  class="form-control"
                  v-model="dk_code"
                  readonly
                />
              </div>
            </div>
            <div class="mb-3">
              <label class="col-12">Pattern</label>
              <div class="col-12">
                <input
                  type="text"
                  class="form-control"
                  v-model="cdp_name"
                  readonly
                />
              </div>
            </div>
            <div class="mb-3">
              <label class="col-12">Effective date</label>
              <div class="col-12">
                <input
                  type="text"
                  class="form-control"
                  v-model="cdc_date"
                  readonly
                />
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label class="col-12">Plant Code</label>
              <div class="col-12">
                <input
                  type="text"
                  v-model="spl_plant_code"
                  class="form-control"
                  readonly
                />
              </div>
            </div>
            <div class="mb-3">
              <label class="col-12">Order Process Category</label>
              <div class="col-12">
                <input
                  type="text"
                  class="form-control"
                  v-model="opc_name"
                  readonly
                />
              </div>
            </div>
            <div class="mb-3">
              <label class="col-12">Truck No.</label>
              <div class="col-12">
                <input
                  type="number"
                  v-model="cdc_truck_no"
                  class="form-control"
                  required
                />
                <div class="invalid-feedback">
                  Please enter Truck No.
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label class="col-12">Order Cycle</label>
              <div class="row">
                <div class="col-4">
                  <input
                    type="number"
                    class="form-control"
                    v-model="cdc_cycle_x"
                    required
                  />
                  <div class="invalid-feedback">
                    Please enter x.
                  </div>
                </div>
                <div class="col-4">
                  <input
                    type="number"
                    class="form-control"
                    v-model="cdc_cycle_y"
                    required
                  />
                  <div class="invalid-feedback">
                    Please enter y.
                  </div>
                </div>
                <div class="col-4">
                  <input
                    type="number"
                    class="form-control"
                    v-model="cdc_cycle_z"
                    required
                  />
                  <div class="invalid-feedback">
                    Please enter z.
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label class="col-12">Delivery Cycle</label>
              <div class="row">
                <div class="col-4">
                  <input
                    type="number"
                    class="form-control"
                    v-model="cdc_delivery_x"
                    required
                  />
                  <div class="invalid-feedback">
                    Please enter x.
                  </div>
                </div>
                <div class="col-4">
                  <input
                    type="number"
                    class="form-control"
                    v-model="cdc_delivery_y"
                    required
                  />
                  <div class="invalid-feedback">
                    Please enter y.
                  </div>
                </div>
                <div class="col-4">
                  <input
                    type="number"
                    class="form-control"
                    v-model="cdc_delivery_z"
                    required
                  />
                  <div class="invalid-feedback">
                    Please enter z.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table customize-table mb-0 v-middle">
              <thead class="table-light">
                <tr>
                  <th
                    class=""
                    style="width: 25%;"
                  >Truck</th>
                  <th
                    class=""
                    style="width: 50%;"
                  >Ordering Time</th>
                  <th
                    class=""
                    style="width: 25%;"
                  >Category</th>
                </tr>
              </thead>
              <tbody v-if="cycleModalList.length > 0">
                <tr
                  v-for="(rsl, j) in cycleModalList"
                  :key="'rs' + j"
                >
                  <td class="align-top">
                    <input
                      type="text"
                      class="form-control"
                      v-model="rsl.cdcl_truck_no"
                      required
                      :disabled="checkExpire() < 0"
                    />
                  </td>
                  <td class="align-top">
                    <div class="row">
                      <div class="col-6">
                        <select
                          v-model="rsl.cdcl_time_h"
                          class="form-control-line form-select form-select-fix"
                          style="width: 100%"
                          required
                          placeholder="Choose time house"
                          :disabled="checkExpire() < 0"
                        >
                          <option
                            v-for="(rth, h) in array_h"
                            :key="'rth' + h"
                            :value="rth"
                          >
                            {{ rth }}
                          </option>
                        </select>
                      </div>
                      <div class="col-6">
                        <select
                          v-model="rsl.cdcl_time_m"
                          class="form-control-line form-select form-select-fix"
                          required
                          placeholder="Choose time house"
                          :disabled="checkExpire() < 0"
                        >
                          <option
                            v-for="(rtm, m) in array_m"
                            :key="'rtm' + m"
                            :value="rtm"
                          >
                            {{ rtm }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </td>
                  <td class="align-top">{{ rsl.cdcl_category }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary btn-fix"
        data-bs-dismiss="modal"
        id="cycleModalclose"
      ><i class="fa fa-times"></i> Close</button>
      <button
        type="button"
        class="btn btn-info btn-fix"
        @click="checkForm"
        id="submitbtn"
      ><i class="fas fa-save"></i> Save</button>
    </div>
  </div>
</template>

<script>
import api from '../../models/cycle'

export default {
  props: ['modalEditCycle', 'loadNewCycle'],
  data () {
    return {
      cdc_id: '',
      opc_name: '',
      cdp_name: '',
      dk_code: '',
      cdc_date: '',
      cdc_truck_no: '',
      cdc_cycle_x: '',
      cdc_cycle_y: '',
      cdc_cycle_z: '',
      cdc_delivery_x: '',
      cdc_delivery_y: '',
      cdc_delivery_z: '',
      spl_id: '',
      spl_code: '',
      spl_name: '',
      spl_plant_code: '',
      cycleModalList: [],
      array_h: [
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24',
        '25',
        '26',
        '27',
        '28',
        '29',
        '30',
        '31'
      ],
      array_m: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55']
    }
  },
  methods: {
    checkForm () {
      if (this.cdc_truck_no !== '' && this.cdc_cycle_x !== '' && this.cdc_cycle_y !== '' && this.cdc_cycle_z !== '') {
        this.updateCycle()
      } else {
        $('#formEditCycle').addClass('was-validated')
      }
    },
    checkExpire () {
      const a = new Date()
      const date = this.dateConvertYMD(this.cdc_date)
      const b = new Date(date)
      return parseInt((b - a) / 1000)
    },
    updateCycle () {
      $('.preloader').fadeIn()
      let formData = {
        cdc_truck_no: this.cdc_truck_no,
        cdc_cycle_x: this.cdc_cycle_x,
        cdc_cycle_y: this.cdc_cycle_y,
        cdc_cycle_z: this.cdc_cycle_z,
        cdc_delivery_x: this.cdc_delivery_x,
        cdc_delivery_y: this.cdc_delivery_y,
        cdc_delivery_z: this.cdc_delivery_z,
        cycle_list: this.cycleModalList
      }
      api.editCycle(
        this.$store.state.URLHost,
        this.cdc_id,
        formData,
        this.header,
        result => {
          if (result.response === true) {
            this.loadNewCycle()
            this.alert_msg('success', 'Successful', result.message)
            $('.preloader').fadeOut()
            $('#CycleModal').modal('hide')
          } else {
            this.loadNewCycle()
            this.alert_msg('warning', 'An error occurred.', result.message)
            $('.preloader').fadeOut()
            $('#CycleModal').modal('hide')
          }
        },
        error => {
          this.loadNewCycle()
          this.alert_msg('error', 'An error occurred.', error.message)
          $('.preloader').fadeOut()
          $('#CycleModal').modal('hide')
        }
      )
    }
  },
  watch: {
    modalEditCycle: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.cdc_id = newValue.cdc_id
        this.spl_id = newValue.spl_id
        this.spl_code = newValue.spl_code
        this.spl_name = newValue.spl_name
        this.spl_plant_code = newValue.spl_plant_code
        this.opc_name = newValue.opc_name
        this.cdp_name = newValue.cdp_name
        this.dk_code = newValue.dk_code
        this.cdc_date = this.dateFormatDMY(newValue.cdc_date)
        this.cdc_truck_no = newValue.cdc_truck_no
        this.cdc_cycle_x = newValue.cdc_cycle_x
        this.cdc_cycle_y = newValue.cdc_cycle_y
        this.cdc_cycle_z = newValue.cdc_cycle_z
        this.cdc_delivery_x = newValue.cdc_delivery_x
        this.cdc_delivery_y = newValue.cdc_delivery_y
        this.cdc_delivery_z = newValue.cdc_delivery_z
        this.cycleModalList = newValue.cycle_list_data
        $(document).on('show.bs.modal', '.modal', function () {
          var zIndex = 1040 + 10 * $('.modal:visible').length
          $(this).css('z-index', zIndex)
          setTimeout(function () {
            $('.modal-backdrop')
              .not('.modal-stack')
              .css('z-index', zIndex - 1)
              .addClass('modal-stack')
          }, 0)
        })
      }
    }
  },
  mounted () {
    var myModalEl = document.getElementById('CycleModal')
    myModalEl.addEventListener('hide.bs.modal', event => {
      // this.cdc_id = this.modalEditCycle.cdc_id
      // this.spl_id = this.modalEditCycle.spl_id
      // this.cdc_date = this.dateFormatDMY2(this.modalEditCycle.cdc_date)
      // this.cdc_truck_no = this.modalEditCycle.cdc_truck_no
      // this.cdc_cycle_x = this.modalEditCycle.cdc_cycle_x
      // this.cdc_cycle_y = this.modalEditCycle.cdc_cycle_y
      // this.cdc_cycle_z = this.modalEditCycle.cdc_cycle_z
      // this.cdc_delivery_x = this.modalEditCycle.cdc_delivery_x
      // this.cdc_delivery_y = this.modalEditCycle.cdc_delivery_y
      // this.cdc_delivery_z = this.modalEditCycle.cdc_delivery_z
      // this.cycleModalList = this.modalEditCycle.cycle_list_data
      this.cdc_date = ''
      $('#formEditCycle').removeClass('was-validated')
    })
    $(document).on('show.bs.modal', '.modal', function () {
      var zIndex = 1040 + 10 * $('.modal:visible').length
      $(this).css('z-index', zIndex)
      setTimeout(function () {
        $('.modal-backdrop')
          .not('.modal-stack')
          .css('z-index', zIndex - 1)
          .addClass('modal-stack')
      }, 0)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/cycle_edit_modal.vue